"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var _FormLabel = _interopRequireDefault(require("@mui/material/FormLabel"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _index = require("../../utils/index");
var _DefaultColourButton = _interopRequireDefault(require("../../Misc/DefaultColourButton/DefaultColourButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Contact({
  t = text => text,
  handleSubmit,
  submitted = false,
  initialValues = {},
  disableCheckboxes = false,
  id = "contact-form",
  isPublisher,
  freeTrialAvailable
}) {
  const [values, setValues] = (0, _react.useState)({
    firstName: "",
    lastName: "",
    email: "",
    publisher: isPublisher ? true : false,
    role: "",
    schoolName: "",
    schoolDistrict: "",
    city: "",
    state: "",
    subject: "",
    message: "",
    freeTrial: false,
    requestDemo: false,
    newsAndUpdates: false,
    ...initialValues
  });
  const handleChange = event => {
    const target = event.target;
    const {
      name,
      checked,
      type
    } = target;
    const value = type === "checkbox" ? checked : target.value;
    setValues(prevValues => ({
      ...prevValues,
      [name]: value
    }));
  };
  const submit = e => {
    e.preventDefault();
    handleSubmit(values);
  };
  const {
    firstName,
    lastName,
    email,
    role,
    schoolName,
    schoolDistrict,
    city,
    state,
    message,
    freeTrial,
    requestDemo,
    newsAndUpdates
  } = values;
  const roles = [{
    value: "",
    label: "none"
  }, {
    value: "teacher",
    label: "teacher"
  }, {
    value: "principal",
    label: "principal"
  }, {
    value: "tutor",
    label: "tutor"
  }, {
    value: "parent",
    label: "parent"
  }, {
    value: "student",
    label: "student"
  }, {
    value: "other",
    label: "other"
  }];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
    onSubmit: submit,
    id: id,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      sx: theme => ({
        minWidth: 300,
        width: "100%",
        maxWidth: 650,
        padding: theme.spacing(2)
      }),
      children: submitted ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        variant: "body1",
        gutterBottom: true,
        children: t("thank_you_for_submitting")
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          variant: "body1",
          gutterBottom: true,
          children: t("fill_in_contact_form")
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid, {
          container: true,
          spacing: 2,
          sx: theme => ({
            marginTop: theme.spacing(1)
          }),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
            size: {
              xs: 12,
              md: 12
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
              fontSize: 14,
              sx: {
                opacity: 0.8,
                marginBottom: 1
              },
              children: t("required_field")
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
            size: {
              xs: 12,
              md: 6
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
              id: `firstName`,
              name: "firstName",
              variant: "outlined",
              label: t("first_name"),
              value: firstName,
              onChange: handleChange,
              fullWidth: true,
              inputProps: {
                maxLength: 50
              },
              required: true
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
            size: {
              xs: 12,
              md: 6
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
              id: `lastName`,
              name: "lastName",
              variant: "outlined",
              label: t("last_name"),
              value: lastName,
              onChange: handleChange,
              fullWidth: true,
              inputProps: {
                maxLength: 50
              },
              required: true
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
            size: 12,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
              id: `email`,
              name: "email",
              type: "email",
              variant: "outlined",
              label: t("email"),
              value: email,
              onChange: handleChange,
              fullWidth: true,
              inputProps: {
                maxLength: 300
              },
              required: true
            })
          }), !isPublisher && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
              size: 12,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
                id: "role",
                select: true,
                label: t("role"),
                name: "role",
                value: role,
                onChange: handleChange,
                variant: "outlined",
                fullWidth: true,
                required: true,
                children: roles.map(option => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
                  value: option.value,
                  children: t(option.label)
                }, option.value))
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
              size: 12,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
                id: `schoolName`,
                name: "schoolName",
                variant: "outlined",
                label: t("school_name"),
                value: schoolName,
                onChange: handleChange,
                fullWidth: true,
                inputProps: {
                  maxLength: 100
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
              size: 12,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
                id: `schoolDistrict`,
                name: "schoolDistrict",
                variant: "outlined",
                label: t("school_district"),
                value: schoolDistrict,
                onChange: handleChange,
                fullWidth: true,
                inputProps: {
                  maxLength: 100
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
              size: {
                xs: 12,
                md: 6
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
                id: `city`,
                name: "city",
                variant: "outlined",
                label: t("city"),
                value: city,
                onChange: handleChange,
                fullWidth: true,
                inputProps: {
                  maxLength: 100
                }
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
              size: {
                xs: 12,
                md: 6
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
                id: `state`,
                name: "state",
                variant: "outlined",
                label: t("state"),
                value: state,
                onChange: handleChange,
                fullWidth: true,
                inputProps: {
                  maxLength: 100
                }
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
            size: 12,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
              id: `message_${(0, _index.randomId)()}`,
              name: "message",
              variant: "outlined",
              label: t("message"),
              value: message,
              onChange: handleChange,
              fullWidth: true,
              inputProps: {
                maxLength: 1000
              },
              multiline: true,
              rows: 3,
              maxRows: 3
            })
          }), !disableCheckboxes && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
            size: 12,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
              component: "fieldset",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormLabel.default, {
                component: "legend",
                children: t("sign_me_up")
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormGroup.default, {
                sx: {
                  flexDirection: "row"
                },
                children: [freeTrialAvailable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
                  control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
                    checked: freeTrial,
                    onChange: handleChange,
                    name: "freeTrial"
                  }),
                  label: t("free_trial")
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
                  control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
                    checked: requestDemo,
                    onChange: handleChange,
                    name: "requestDemo"
                  }),
                  label: t("interactive_demo")
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
                  control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
                    checked: newsAndUpdates,
                    onChange: handleChange,
                    name: "newsAndUpdates"
                  }),
                  label: t("news_and_updates")
                })]
              })]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid, {
            size: 12,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DefaultColourButton.default, {
              type: "submit",
              variant: "contained",
              children: t("send_message")
            })
          })]
        })]
      })
    })
  });
}
var _default = exports.default = Contact;